import { render, staticRenderFns } from "./patientReported.vue?vue&type=template&id=03573008&"
import script from "./patientReported.vue?vue&type=script&lang=js&"
export * from "./patientReported.vue?vue&type=script&lang=js&"
import style0 from "./patientReported.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports